module.exports = __webpack_public_path__ + "resources/img/ionic.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/ionic.png
// module id = 1104
// module chunks = 0